import React, { Component } from "react";
import axios from "axios";
import classes from "./Ebookviewer.module.css";
import { Document } from 'react-pdf'

import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import { createBrowserHistory } from 'history';
import { ProgressBar } from 'react-bootstrap';
import { getPath } from "../../../util/getPath";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'

let history = createBrowserHistory();


class Ebookviewer extends Component {

  constructor() {
    super();

    this.state = {
      loading: false,
      courseID: '',
    }
  }

  componentDidMount() {
    let url = window.location.href;
    let getID = url.substr(url.lastIndexOf("/") + 1);
    this.setState({
      courseID: getID
    })
  }    


    render() {


    const loading = this.state.loading;


    return (
      <div className={classes.Wrapper}>

        
        <div className={classes.Back} id={'secondary'} onClick={() => {
          document.location= '/'
        }}>
          <FontAwesomeIcon icon={faArrowLeft} /> BACK
          </div>
        {loading ? (
          <LoadingSpinner />
        ) : (
            <div>
              <iframe className={classes.Iframe} src={`${getPath()}assets/courses/${this.state.courseID}/ebook/1.pdf`}></iframe>
              </div>
        )}
      </div>
    );
  }
}

export default Ebookviewer;
